/* src/app/shared/components/simple-table/simple-table.component.scss */
@font-face {
  font-family: "Neue Simon Kucher";
  src: url("./media/NeueSimonKucher-Regular.ttf") format("truetype");
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "Neue Simon Kucher";
  src: url("./media/NeueSimonKucher-RegularItalic.ttf") format("truetype");
  font-style: italic;
  font-weight: 500;
}
@font-face {
  font-family: "Neue Simon Kucher";
  src: url("./media/NeueSimonKucher-Bold.ttf") format("truetype");
  font-style: normal;
  font-weight: bold;
}
@font-face {
  font-family: "Neue Simon Kucher";
  src: url("./media/NeueSimonKucher-BoldItalic.ttf") format("truetype");
  font-style: italic;
  font-weight: bold;
}
.container-box {
  background: #fff;
}
.filter-container {
  position: relative;
  padding: 0;
  min-height: 10.5rem;
}
.box-container {
  overflow: hidden;
  position: relative;
  margin-right: 0.5rem;
  padding: 0;
  min-height: 10.5rem;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #FFF;
}
.box-container .box-header {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 1rem;
  color: var(--secondary);
}
.box-container .box-header.h6 {
  font-size: 1rem;
  margin-top: 1.2rem;
}
.box-container .box-body {
  padding: 0.1rem 0.8rem;
}
.collapse-filters {
  position: absolute;
  z-index: 100;
  width: 100.5%;
  margin-left: -1.3rem;
  padding-left: 1.6rem;
  background: #fff;
  border-left: 5px solid rgb(109, 110, 106);
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1);
}
::ng-deep .ant-select {
  margin-top: 0;
}
::ng-deep .nz-checkbox-wrapper label {
  top: 0.2rem !important;
}
.table {
  background-color: #fff;
  border-collapse: separate;
  border-spacing: 0 15px;
  margin-bottom: 3rem;
}
.table tr.tbodyRows {
  border-spacing: 2rem;
  box-shadow: 1px 1px 15px rgba(0, 0, 0, 0.1);
  border-radius: 1rem;
}
.table tr {
  display: revert !important;
}
.table tr th {
  background: #F2F2F3;
  position: relative;
}
.table tr th span i {
  margin-left: 10px;
  font-size: 17px !important;
  opacity: 0.3;
}
.table tr th span.activeSorting i {
  opacity: 1;
}
.table tr td {
  border: none !important;
  color: #191919;
  font-size: 1rem;
}
.table tr td a {
  color: #191919;
  text-decoration: none;
}
.table tr td i {
  font-size: 1rem;
}
.table tr td i.material-icons-archive {
  font-size: 1.4rem;
}
.table tr td .downloadIcon {
  color: var(--primary);
  cursor: pointer;
  margin-left: 0.1rem;
}
.table tr td .downloadIcon i {
  font-size: 1.1rem;
}
.table tr td .failedIcon {
  color: var(--primary);
}
.table tr td .failedIcon i {
  font-size: 1.4rem;
}
.table tr td p.ellipsisSpan {
  white-space: nowrap;
  max-width: 150px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0;
}
.table tr .smallWidth {
  width: 150px;
}
.table tr td.StatusColumn {
  color: #00a887;
}
.table tr td.ellipsisCell {
  max-width: 150px;
}
.table tr th:first-child,
.table tr td:first-child {
  border-radius: 1rem 0px 0px 1rem;
}
.table tr th:last-child,
.table tr td:last-child {
  border-radius: 0 1rem 1rem 0;
}
.table tr:hover {
  background: #eeeef6;
  cursor: pointer;
  border-radius: 1rem;
}
.table tr.emptyRow:hover {
  background: transparent;
  cursor: initial;
}
.addBtn button span i {
  font-size: 0.9rem;
}
.actionsColumns span {
  margin-right: 15px;
}
.actionsColumns i {
  cursor: pointer;
}
.actionsColumns span:hover {
  color: #831038;
}
.actionsColumns .uploadContainer {
  border: 1px solid #191919;
  padding: 0.125rem 0.782rem;
  border-radius: 0.5rem;
}
.actionsColumns .dropdown-menu {
  padding: 1rem;
  border-radius: 0.5rem;
}
.actionsColumns .dropdown-menu li {
  margin-bottom: 1rem;
  cursor: pointer;
}
.actionsColumns .dropdown-menu li span {
  width: 15px;
  text-align: left;
  margin-right: 10px;
  text-align: center;
}
.actionsColumns .dropdown-menu li:last-child {
  margin-bottom: 0;
}
.actionsColumns .dropdown-menu li:hover {
  color: #ba1750;
}
/*# sourceMappingURL=simple-table.component.css.map */
